module.exports = function () {
    var selectTab = function ($tabContainer, tabId) {
        var $option = $tabContainer.find('.two-column-tabs-option[data-tab-id="' + tabId + '"]');

        $tabContainer.find('.two-column-tabs-option-active').removeClass('two-column-tabs-option-active');
        $tabContainer.find('.two-column-tabs-tab-active').removeClass('two-column-tabs-tab-active');

        $option.addClass('two-column-tabs-option-active');

        var $tab = $tabContainer.find('.two-column-tabs-tab[data-tab-id="' + tabId + '"]').first();
        $tab.addClass('two-column-tabs-tab-active');

        aos.refresh();
    };

    $('.two-column-tabs-option').click(function() {
        var $option = $(this);
        var tabId = $option.data('tabId');
        var $tabContainer = $option.parents('.two-column-tabs').first();

        selectTab($tabContainer, tabId);
    });

    $('.two-column-tabs-dropdown select').change(function() {
        var tabId = $(this).val();
        var $tabContainer = $(this).parents('.two-column-tabs').first();

        selectTab($tabContainer, tabId);
    });
};